import { ReactElement } from 'react';
import styles from './beacon-status.module.scss';
import { Battery, MapPopup } from '@/common/components';
import { Beacon } from '@/api';
import { UIIcon, UIPopover } from '@/ui';
import { charcoal } from '@/ui/styles';

type BeaconStatusProps = {
    beacon: Beacon;
    showLocation?: boolean;
    showBattery?: boolean;
};
export function BeaconStatus(props: BeaconStatusProps): ReactElement {
    const { beacon, showLocation = true, showBattery = true } = props;
    const { battery, location } = beacon;
    return (
        <div className={styles.statusCellContainer}>
            {showBattery && (
                <Battery
                    battery={
                        battery
                            ? {
                                  level: battery.level,
                                  isCharging: false,
                                  timestamp: new Date(battery.updatedAt)
                              }
                            : null
                    }
                    withLevel={false}
                />
            )}
            {location && showLocation && (
                <UIPopover
                    placement="bottom_left"
                    trigger="hover"
                    width={300}
                    triggerNode={
                        <div className={styles.mapIconContainer}>
                            <UIIcon name="map-pin" size={16} color={charcoal} />
                        </div>
                    }
                >
                    <MapPopup lat={location.lat} lng={location.lng} />
                </UIPopover>
            )}
        </div>
    );
}
